import React from 'react';
import styled from 'styled-components';
import PText from './PText';

const AboutItemStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  /* gap: 5rem; */
  margin-top: 3rem;
  .title {
    font-size: 2.1rem;
    color: var(--primary);
  }
  .items {
    display: flex;
    gap: 1.5rem;
    position: absolute;
    left: 30rem;
    align-items: flex-start; /* avoid stretching all items to tallest height */
  }
  .item {
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 8px;
    line-height: 1.2;
  }
  .item p {
    margin: 0; /* remove default p top/bottom margins inside pills */
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    .items {
      position: initial;
      gap: 1rem;
    }
    .title {
      font-size: 2rem;
    }
  }
`;

function AboutInfoItem({ title = 'This is title', items = ['HTML', 'CSS'] }) {
  return (
    <AboutItemStyles>
      <h1 className="title">{title}</h1>
      <div className="items">
        {items.map((item, index) => (
          <div className="item" key={index}>
            <PText>{item}</PText>
          </div>
        ))}
      </div>
    </AboutItemStyles>
  );
}

export default AboutInfoItem;
